import Vue from 'vue'
import VueCountdown from '@xkeshi/vue-countdown'

Vue.component(VueCountdown.name, VueCountdown)



// WEBPACK FOOTER //
// ./src/plugins/components/countDown.js